import TopSection from "../../compontents/common/TopSection";
import MainSection from "../../compontents/common/MainSection";

import StoryGrid from "../../compontents/story/StoryGrid";

export default function StoryList() {
    return (
        <>
            <TopSection
                title={"Inspiring\nStories"}
                desc="Read our stories about design, art and lifestyle"
            />

            <MainSection paddingAmount="150px 0px">
                <StoryGrid />
            </MainSection>
        </>
    );
}
